import GroupIconMui from '@mui/icons-material/Group';

export const GroupIcon = GroupIconMui;
